import React, { useEffect, useState } from 'react'
import { LoaderWrapper, ReportHeading, ReportOuterWrapper } from '../../../../components'
import { GRAPH_COLOR_PALLET4 } from '../../../../constants'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import BrandBar from './brandBar'
import { MultiBarContainer, RootWrap } from './style'
import { exportExcel_addPercentage } from '../../../../util'

const MultiBrandNPS = (props) => {
  const [state, setStage] = useState([])
  const [max, setMax] = useState(0)
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [eventCount, setEventCount] = useState(1)

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: ReportsService.getNPSElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  useEffect(() => {
    if (state.length) {
      const bar = document.querySelectorAll('.barWrapper .brandBarTitle')
      let titleHeight = 0
      for (let i = 0; i < bar.length; i++) {
        titleHeight = bar[i].clientHeight > titleHeight ? bar[i].clientHeight : titleHeight
      }
      for (let i = 0; i < bar.length; i++) {
        bar[i].style.height = titleHeight + 'px'
      }
    }
  }, [state])

  const onSuccessFunc = (resp) => {
    setStage(resp)
    const percentages = resp.map((item) => item.NPSPercent)
    setMax(Math.max(...percentages))
    setTimeout(() => {
      setEventCount((p) => p + 1)
      updateSubLhsApiLoaded(props)
    }, 2000)

    setReportExcelData({
      heading: ['Brand', 'NPS'],
      values: resp.map((d) => {
        return [{ value: d.BrandName }, exportExcel_addPercentage(d.NPSPercent)]
      }),
    })
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        {...props}
        downloadIdData={reportExcelData}
      />
      <ReportOuterWrapper>
        <RootWrap id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            {props?.isPPTModalActive 
              ? <> {
               // If there are more than 12 brands, split into two columns (two MultiBarContainer)
                (() => {
                  const len = state?.length || 0
                  if (len > 12) {
                    const mid = Math.ceil(len / 2)
                    const left = state.slice(0, mid)
                    const right = state.slice(mid)
                    return (
                      <>
                        <MultiBarContainer className='barWrapper'>
                          {left.map((item, i) => (
                            <BrandBar
                              maxValue={max}
                              color={GRAPH_COLOR_PALLET4[i]}
                              key={`L-${i}`}
                              value={item.NPSPercent}
                              title={item.BrandName}
                            />
                          ))}
                        </MultiBarContainer>
                        <MultiBarContainer className='barWrapper'>
                          {right.map((item, i) => (
                            <BrandBar
                              maxValue={max}
                              color={GRAPH_COLOR_PALLET4[i + mid]}
                              key={`R-${i}`}
                              value={item.NPSPercent}
                              title={item.BrandName}
                            />
                          ))}
                        </MultiBarContainer>
                      </>
                    )
                  }

                  // default: single container
                  return (
                    <MultiBarContainer className='barWrapper'>
                      {state?.map((item, index) => (
                        <BrandBar
                          maxValue={max}
                          color={GRAPH_COLOR_PALLET4[index]}
                          key={index}
                          value={item.NPSPercent}
                          title={item.BrandName}
                        />
                      ))}
                    </MultiBarContainer>
                  )
                })()
              } </>
              : <MultiBarContainer className='barWrapper'>
                {state?.map((item, index) => (
                  <BrandBar
                    maxValue={max}
                    color={GRAPH_COLOR_PALLET4[index]}
                    key={index}
                    value={item.NPSPercent}
                    title={item.BrandName}
                  />
                ))}
              </MultiBarContainer>
            }
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default MultiBrandNPS
